import {Column} from 'primereact/column';
import {DataTable} from 'primereact/datatable';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import NumberFormat from 'react-number-format';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import CustomDialog from '../components/CustomDialog';
import {CustomMessages} from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import InputTextComponent from '../components/inputs/InputTextComponent';
import TransactionModel from '../model/TransactionModel';
import CardService from '../services/CardService';
import TransactionService from '../services/TransactionService';
import moment from 'moment';

class TrasactionDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new TransactionService());
        this.cardService = new CardService();
        this.state = {
            elementId: props.elementId,
            element: new TransactionModel(),
            edited: {
                registrationNumber: '',
                driver: '',
                odometer: '',
            },
            required: {
                vehicle: false,
                driver: false,
                odometer: false,
                mpk: false,
            },
            viewMode: 'VIEW',
            showDialog: false,
        };
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    initAfterSetElement() {
        this.unblockUi();
        const {t} = this.props;
        if (this.isUserHasAnyPermission('PERMISSION_VIEW_FLEET_CARDS', 'PERMISSION_EDIT_FLEET_CARDS')) {
            this.cardService
                .getCardDetailsRequired(this.state.element.cardNumber)
                .then((res) => {
                    this.setState({
                        required: {
                            vehicle: res.vehicleRequired,
                            driver: res.driverRequired,
                            odometer: res.odometerRequired,
                            mpk: res.mpkRequired,
                        },
                    });
                    this.refreshTable();
                    this.unblockUi();
                })
                .catch((err) => {
                    this.unblockUi();
                });
        }
    }

    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12 transaction-dialog-header'>
                <DivContainer colClass='col-12'>
                    <label>
                        {t('transaction.detailsHeader')} {this.state.element.petraId}
                    </label>
                </DivContainer>
            </DivContainer>
        );
    }

    updateElement(data) {
        this.setState(
            {
                element: TransactionModel.copy(data),
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }

    setElement() {
        if (this.props.element) {
            this.updateElement(this.props.element);
        }
    }

    getContainerListName() {
        return 'transaction-list-container';
    }

    getAddSucces() {
        return 'Osoba kontaktowa została utworzona';
    }

    getUpdateSucces() {
        return 'Osoba kontaktowa została zaktualizowana';
    }

    createOrUpdate() {
        const {element} = this.state;
        this.scrollToTop();
        if (this._isMounted) {
            if (element.id === undefined || element.id === null) {
                this.service
                    .add(element)
                    .then((response) => {
                        this.blockUi();
                        this.persistMessage('success', '', this.getAddSucces(response));
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        this.persistMessage('error', '', err.message);
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    });
            } else {
                this.service
                    .update(element)
                    .then((response) => {
                        this.blockUi();
                        this.persistMessage('success', '', this.getUpdateSucces(response));
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        this.persistMessage('error', '', err.message);
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    });
            }
        }
    }

    editTransaction(request, petraId) {
        const {t} = this.props;
        if (this.validator.allValid()) {
            this.service
                .editTransaction(request, petraId)
                .then(() => {
                    this.setState(
                        (prevState) => ({
                            ...prevState,
                            showDialog: false,
                            element: {
                                ...prevState.element,
                                registrationNumber: this.state.edited.registrationNumber,
                                driver: this.state.edited.driver,
                                odometer: this.state.edited.odometer,
                            },
                        }),
                        () => {
                            if (this.props.afterSave) {
                                this.props.afterSave();
                            }
                            this.showSuccessMessage(t('transaction.editSuccess'));
                        }
                    );
                })
                .catch(() => {
                    this.showErrorMessage(t('error.editTransactionError'));
                    this.setState({showDialog: false});
                });
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    renderEditDialog() {
        const {t} = this.props;
        return (
            <CustomDialog
                onHide={(e) => this.setState({showDialog: false})}
                visible={this.state.showDialog && this.state.element.editable}
                viewMode='EDIT'
                afterSave={(e) =>
                    this.handleCloseDialog(e, () => {
                        this.readMessage();
                        this.refreshTable();
                    })
                }
                modal={true}
                className='transaction-dialog-edit'
                header={
                    <label>
                        {t('transaction.editHeader')} {this.state.element.petraId}
                    </label>
                }
            >
                <DivContainer colClass='row'>
                    <InputTextComponent
                        id='registrationNumber'
                        name='registrationNumber'
                        label={t('transaction.registrationNumberFullName')}
                        colClass='col-md-12'
                        value={this.state.edited.registrationNumber}
                        validator={this.validator}
                        max={10}
                        validators={this.state.required.vehicle === true ? 'required|alpha_num|max:10' : 'not_required|alpha_num|max:10'}
                        onChange={this.handleChange}
                        viewMode='EDIT'
                        stateField='edited'
                        forceUpperCase
                        keyfilter={/^[A-Z0-9]*$/i}
                    />
                    <InputTextComponent
                        id='odometer'
                        name='odometer'
                        label={t('transaction.odometer')}
                        colClass='col-md-12'
                        value={this.state.edited.odometer}
                        validator={this.validator}
                        validators={this.state.required.odometer === true ? 'required|integer|max:7' : 'not_required|integer|max:7'}
                        onChange={this.handleChange}
                        viewMode='EDIT'
                        stateField='edited'
                        forceUpperCase
                        keyfilter={/^[0-9]*$/i}
                    />
                    <InputTextComponent
                        id='driver'
                        name='driver'
                        label={t('transaction.fullName')}
                        colClass='col-md-12'
                        value={this.state.edited.driver}
                        validator={this.validator}
                        validators={this.state.required.driver === true ? 'required|alpha_space_dash|max:50' : 'not_required|alpha_space_dash|max:50'}
                        onChange={this.handleChange}
                        viewMode='EDIT'
                        stateField='edited'
                        forceUpperCase
                        keyfilter={/^[A-ZĄĆĘŁŃÓŚŹŻąćęłńóśźż\s-]*$/i}
                    />
                </DivContainer>
                <DivContainer colClass='row transaction-buttons'>
                    <DivContainer colClass='col-md-6 transaction-button'>
                        <ActionButton
                            label={t('details.cancel')}
                            handleClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                    showDialog: false,
                                });
                            }}
                            variant='white'
                        />
                    </DivContainer>
                    <DivContainer colClass='col-md-6 transaction-button'>
                        <ActionButton
                            label={t('details.saveChanges')}
                            handleClick={(e) => {
                                e.preventDefault();
                                this.editTransaction(this.state.edited, this.state.element.petraId);
                            }}
                            variant='blue'
                            disabled={!this.isUserHasPermission('PERMISSION_EDIT_TRANSACTIONS')}
                        />
                    </DivContainer>
                </DivContainer>
            </CustomDialog>
        );
    }

    quantityTemplate(rowData) {
        const {t} = this.props;
        if (rowData.measureUnit === 'H') {
            let quantity = '00:00';
            if (rowData.quantity > 0) {
                let hours = Math.floor(rowData.quantity);
                let minutes = Math.round((rowData.quantity - hours) *60);
                quantity = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${t(
                    `measureUnit.${rowData.measureUnit}`
                )}`;
            }
            return <span>{quantity}</span>;
        } else {
            return (
                <NumberFormat
                    value={rowData?.quantity}
                    displayType={'text'}
                    thousandSeparator=' '
                    decimalSeparator=','
                    fixedDecimalScale
                    decimalScale={rowData?.measureUnit === 'ITEM' || rowData?.measureUnit === 'BOX' ? 0 : rowData?.measureUnit === 'KWH'? 3 : 2}
                    renderText={(value) =>
                        rowData.measureUnit !== null ? (
                            <div dangerouslySetInnerHTML={{__html: `${value} ${t(`measureUnit.${rowData.measureUnit}`)}`}} />
                        ) : null
                    }
                />
            );
        }
    }

    summaryTimeTemplate(rowData) {
        let diff = 0;
        if( rowData.startTime !== null && rowData.endTime !== null){
            let starttime = moment(rowData.startTime).format('YYYY-MM-DDTHH:mmZ');
            let endtime = moment(rowData.endTime).format('YYYY-MM-DDTHH:mmZ');
            let result =  Math.abs(moment(starttime).diff(moment(endtime), 'minutes'));
             diff = result;
        }     
        return diff;
    }
    amountTemplate(field, rowData) {
        const {t} = this.props;
        return (
            <span className='transaction-amount-container'>
                <span className='transaction-amount'>
                    {t('invoice.amountGross')}
                    <NumberFormat
                        value={rowData.gross}
                        displayType={'text'}
                        thousandSeparator=' '
                        decimalSeparator=','
                        fixedDecimalScale
                        decimalScale={2}
                        suffix={` ${t('currency.pln')}`}
                        renderText={(value) => value}
                    />
                </span>
                <span className='transaction-amount-vat'>
                    {t('invoice.amountVat')}
                    <NumberFormat
                        value={rowData.vat}
                        displayType={'text'}
                        thousandSeparator=' '
                        decimalSeparator=','
                        fixedDecimalScale
                        decimalScale={2}
                        suffix={` ${t('currency.pln')}`}
                        renderText={(value) => value}
                    />
                </span>
                <span className='transaction-amount-netto'>
                    {t('invoice.amountNet')}
                    <NumberFormat
                        value={rowData.netto}
                        displayType={'text'}
                        thousandSeparator=' '
                        decimalSeparator=','
                        fixedDecimalScale
                        decimalScale={2}
                        suffix={` ${t('currency.pln')}`}
                        renderText={(value) => value}
                    />
                </span>
            </span>
        );
    }

    highwaysGateTimeTemplate(field, rowData) {
        const {t} = this.props;
        const gateName = rowData[field];
        const gateTime = field === 'highwayOutName' ? rowData['endTime'] : rowData['startTime'];
        return (
            <span className='transaction-amount-container'>
                <span className='transaction-amount'>
                    {gateName}
                </span>
                <span className='transaction-amount-container'>
                <span className='transaction-amount'>
                {moment(gateTime).format('YYYY-MM-DD')} {moment(gateTime).format('HH:mm')}
                </span>
            </span>
            </span>
        );
    }


    startFinishDateTemplate(field, rowData) {
        const {t} = this.props;
        return (
            <span className='transaction-amount-container'>
                <span className='transaction-amount'>
                {moment(rowData[field]).format('YYYY-MM-DD')}
                </span>
                <span className='transaction-amount'>
                {moment(rowData[field]).format('HH:mm')}
                </span>
               
            </span>
        );
    }


    unitAmountTemplate(field, rowData) {
        const {t} = this.props;
        return (
            <span className='transaction-amount-container'>
                <span className='transaction-amount'>
                    {t('transaction.unitAfter')}
                    <NumberFormat
                        value={
                            rowData.priceTotAfter !== undefined
                                ? rowData.priceTotAfter
                                : rowData.priceTotBefore !== undefined
                                ? rowData.priceTotBefore
                                : '-'
                        }
                        displayType={'text'}
                        thousandSeparator=' '
                        decimalSeparator=','
                        fixedDecimalScale
                        decimalScale={2}
                        suffix={` ${t('currency.pln')}`}
                        renderText={(value) => value}
                    />
                </span>
               
                {rowData.discountType === "S" ? 
                <span className='transaction-amount-vat'>
                {t('transaction.priceNetAfter')}
                <NumberFormat
                    value={rowData.priceNetAfter !== null ? rowData.priceNetAfter : "-"}
                    displayType={'text'}
                    thousandSeparator=' '
                    decimalSeparator=','
                    fixedDecimalScale
                    decimalScale={2}
                    suffix={` ${t('currency.pln')}`}
                    renderText={(value) => value}
                />
                </span>
                : null}
                 {rowData.discountType === "S" ? 
                <span className='transaction-amount-vat'>
                {t('transaction.spotDiscount')}
                <NumberFormat
                    value={rowData.spotDiscount !== null ? rowData.spotDiscount : "-"}
                    displayType={'text'}
                    thousandSeparator=' '
                    decimalSeparator=','
                    fixedDecimalScale
                    decimalScale={2}
                    suffix={` ${t('currency.pln')}`}
                    renderText={(value) => value}
                />
                </span>
                : 
                <span className='transaction-amount-vat'>
                {t('transaction.unitDiscount')}
                <NumberFormat
                    value={rowData.discount}
                    displayType={'text'}
                    thousandSeparator=' '
                    decimalSeparator=','
                    fixedDecimalScale
                    decimalScale={2}
                    suffix={` ${t('currency.pln')}`}
                    renderText={(value) => value}
                />
            </span>
            }
                  {rowData.discountType === "S" ? 
                <span className='transaction-amount-vat'>
                {t('transaction.spotPriceBefore')}
                <NumberFormat
                    value={rowData.spotPriceBefore !== null ? rowData.spotPriceBefore : "-"}
                    displayType={'text'}
                    thousandSeparator=' '
                    decimalSeparator=','
                    fixedDecimalScale
                    decimalScale={2}
                    suffix={` ${t('currency.pln')}`}
                    renderText={(value) => value}
                />
                </span>
                :     
                <span className='transaction-amount-netto'>
                {t('transaction.unitBefore')}
                <NumberFormat
                    value={
                        rowData.priceTotBefore !== undefined
                            ? rowData.priceTotBefore
                            : rowData.priceTotAfter !== undefined
                            ? rowData.priceTotAfter
                            : '-'
                    }
                    displayType={'text'}
                    thousandSeparator=' '
                    decimalSeparator=','
                    fixedDecimalScale
                    decimalScale={2}
                    suffix={` ${t('currency.pln')}`}
                    renderText={(value) => value}
                />
            </span>}
            
            </span>
        );
    }
    countStartAndFinishTransactionTime(timeType) {
        if (this.state.element?.positions !== null) {
            let minTime = this.state.element?.positions
                ?.map((p) => p.startTime)
                .filter((p) => p !== null)
                .reduce((a, b) => (a < b ? a : b));
            let maxTime = this.state.element?.positions
                ?.map((p) => p.endTime)
                .filter((p) => p !== null)
                .reduce((a, b) => (a > b ? a : b));

            if (timeType === 0) {
                return moment(minTime).format('HH:mm');
            }
            if (timeType === 1) {
                return moment(maxTime).format('HH:mm');
            }
        }
    }

    renderDetails() {
        const {t} = this.props;
        const isHighwayTransaction = this.state.element.transactionType === 3;
        return (
            <React.Fragment>
                <DivContainer colClass='row' rendered={this.state.viewMode === 'VIEW'}>
                    <InputTextComponent
                        id='date'
                        name='date'
                        label={t('transaction.date')}
                        colClass='col-lg-3 col-md-6'
                        value={ this.state.element?.dateTime?.toString() }
                        validator={this.validator}
                        validators='required|max:50'
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                    />
                    <InputTextComponent
                        id='cardNumber'
                        name='cardNumber'
                        label={t('transaction.cardNumber')}
                        colClass='col-lg-3 col-md-6'
                        value={this.state.element.cardNumber}
                        validator={this.validator}
                        validators='required|max:50'
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                    />
                    <InputTextComponent
                        id='stationNumber'
                        name='stationNumber'
                        label={t('transaction.stationNumber')}
                        colClass='col-lg-3 col-md-6'
                        value={this.state.element.stationNumber}
                        validator={this.validator}
                        validators='required|max:50'
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                    />
                    <InputTextComponent
                        id='stationAddress'
                        name='stationAddress'
                        label={t('transaction.stationAddress')}
                        colClass='col-lg-3 col-md-6'
                        value={this.state.element.stationAddress}
                        validator={this.validator}
                        validators='required|max:50'
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                    />
                </DivContainer>
                {this.state.viewMode === 'VIEW' ? <hr id='line-separator' /> : null}
                <DivContainer colClass='row' rendered={this.state.viewMode === 'VIEW'}>
                    <InputTextComponent
                        id='amount'
                        name='amount'
                        label={t('transaction.amountGross')}
                        colClass='col-md-3 col-4'
                        value={this.state.element.amount}
                        validator={this.validator}
                        validators='required|max:50'
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                        renderValue={() => {
                            return (
                                <NumberFormat
                                    value={this.state.element.amount}
                                    displayType={'text'}
                                    thousandSeparator=' '
                                    decimalSeparator=','
                                    fixedDecimalScale
                                    decimalScale={2}
                                    renderText={(value) => value}
                                />
                            );
                        }}
                    />
                    <InputTextComponent
                        id='amountNet'
                        name='amountNet'
                        label={t('transaction.amountNet')}
                        colClass='col-md-3 col-4'
                        value={this.state.element.amountNet}
                        validator={this.validator}
                        validators='required|max:50'
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                        renderValue={() => {
                            return (
                                <NumberFormat
                                    value={this.state.element.amountNet}
                                    displayType={'text'}
                                    thousandSeparator=' '
                                    decimalSeparator=','
                                    fixedDecimalScale
                                    decimalScale={2}
                                    renderText={(value) => value}
                                />
                            );
                        }}
                    />
                    <InputTextComponent
                        id='amountVat'
                        name='amountVat'
                        label={t('transaction.amountVat')}
                        colClass='col-md-3 col-4'
                        value={this.state.element.amountVat}
                        validator={this.validator}
                        validators='required|max:50'
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                        renderValue={() => {
                            return (
                                <NumberFormat
                                    value={this.state.element.amountVat}
                                    displayType={'text'}
                                    thousandSeparator=' '
                                    decimalSeparator=','
                                    fixedDecimalScale
                                    decimalScale={2}
                                    renderText={(value) => value}
                                />
                            );
                        }}
                    />
                </DivContainer>
                {this.state.element.electromobility && this.state.viewMode === 'VIEW' ? <hr id='line-separator' /> : null}
                {this.state.element.electromobility ? (
                    <DivContainer colClass='row' rendered={this.state.viewMode === 'VIEW'}>
                        <InputTextComponent
                            id='startTransactionTime'
                            name='startTransactionTime'
                            label={t('transaction.start')}
                            colClass='col-lg-3 col-md-6'
                            value={this.countStartAndFinishTransactionTime(0)}
                            validator={this.validator}
                            validators='required|max:50'
                            onChange={this.handleChange}
                            viewMode={this.state.viewMode}
                        />
                        <InputTextComponent
                            id='finishTransactionTime'
                            name='finishTransactionTime'
                            label={t('transaction.finish')}
                            colClass='col-lg-3 col-md-6'
                            value={this.countStartAndFinishTransactionTime(1)}
                            validator={this.validator}
                            validators='required|max:50'
                            onChange={this.handleChange}
                            viewMode={this.state.viewMode}
                        />
                        <InputTextComponent
                            id='energyByTransactionSummary'
                            name='energyByTransactionSummary'
                            label={t('transaction.energySummary')}
                            colClass='col-lg-3 col-md-6'
                            value={this.state.element.quantity}
                            validator={this.validator}
                            validators='required|max:50'
                            onChange={this.handleChange}
                            viewMode={this.state.viewMode}
                        />
                    </DivContainer>
                ) : null}

                {this.state.viewMode === 'VIEW' ? <hr id='line-separator' /> : null}
                <DivContainer colClass='row' rendered={this.state.viewMode === 'VIEW'}>
                    <InputTextComponent
                        id='registrationNumber'
                        name='registrationNumber'
                        label={t('transaction.registrationNumberFullName')}
                        colClass='col-lg-3 col-md-6'
                        value={
                            this.state.element.registrationNumber !== undefined &&
                            this.state.element.registrationNumber !== null &&
                            this.state.element.registrationNumber !== ''
                                ? this.state.element.registrationNumber
                                : '-'
                        }
                        validator={this.validator}
                        validators='required|alpha_num|max:10'
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                    />
                    <InputTextComponent
                        id='driver'
                        name='driver'
                        label={t('transaction.fullName')}
                        colClass='col-lg-3 col-md-6'
                        value={
                            this.state.element.driver !== undefined &&
                            this.state.element.driver !== null &&
                            this.state.element.driver !== ''
                                ? this.state.element.driver
                                : '-'
                        }
                        validator={this.validator}
                        validators='required|max:50'
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                    />
                    <InputTextComponent
                        id='odometer'
                        name='odometer'
                        label={t('transaction.odometer')}
                        colClass='col-lg-3 col-md-6'
                        value={
                            this.state.element.odometer !== undefined &&
                            this.state.element.odometer !== null &&
                            this.state.element.odometer !== ''
                                ? this.state.element.odometer
                                : '-'
                        }
                        validator={this.validator}
                        validators='required|max:50'
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                    />
                    <DivContainer
                        colClass='col-width-auto button'
                        rendered={this.state.viewMode === 'VIEW' && this.state.element?.positions?.editable && this.isUserHasPermission('PERMISSION_EDIT_TRANSACTIONS')}
                    >
                        {this.state.element.editable ? (
                            <ActionButton
                                label={t('details.editButton')}
                                handleClick={(e) => {
                                    e.preventDefault();
                                    this.setState({
                                        showDialog: true,
                                        edited: {
                                            registrationNumber: this.state.element?.registrationNumber,
                                            driver: this.state.element?.driver,
                                            odometer: this.state.element?.odometer,
                                        },
                                    });
                                }}
                                variant='white'
                                iconSvg='ico_pencil'
                                iconSide='left'
                                rendered={this.isUserHasPermission('PERMISSION_EDIT_TRANSACTIONS')}
                            />
                        ) : null}
                    </DivContainer>
                </DivContainer>
                {this.state.viewMode === 'VIEW' ? <hr id='line-separator' /> : null}
                <DivContainer colClass='row' rendered={this.state.viewMode === 'VIEW'}>
                    <DataTable
                        id='dataTable'
                        key='data-table'
                        emptyMessage={this.translate('list.empty')}
                        className='p-datatable-responsive'
                        responsive
                        breakpoint='0px'
                        value={this.state.element.positions}
                        sortOrder={-1}
                        rows={this.state.element.positions?.length}
                        lazy={this.props.lazy}
                        onPage={this.handlePage}
                        onSort={this.handleSort}
                        expandedRows={this.state.expandedRows}
                        onRowToggle={this.handleOnRowToggle}
                        onRowExpand={this.handleOnRowExpand}
                        onRowCollapse={this.handleOnRowCollapse}
                        rowExpansionTemplate={this.rowExpansionTemplate}
                        rowClassName={this.props.rowClassName}
                    >
                        <Column
                            body={(el) => {
                                if (this.state.element.electromobility) {
                                    return el.name === 'EV_STOP' && el.gross === null ? t(`transaction.evStopWithoutPay`) : el.ecName;
                                } else if(isHighwayTransaction){
                                    return el.name ;

                                } else if (el.isFuel) {
                                    return t(`products.${el.name}`);
                                } else {
                                    return el.ecName;
                                }
                            }}
                            header={
                                this.state.element.electromobility === true ? t('transaction.chargeProducts') : t('transaction.products')
                            }
                        />
                        {isHighwayTransaction ? (
                            <Column
                                field='highwayInName'
                                header={ t('transaction.entryGateName') }
                               body={this.highwaysGateTimeTemplate.bind(this, 'highwayInName')}
                            />
                        ) : null}
                          {isHighwayTransaction ? (
                            <Column
                                field='highwayOutName'
                                header={ t('transaction.exitGateName') }
                               body={this.highwaysGateTimeTemplate.bind(this, 'highwayOutName')}
                            />
                        ) : null}
                        <Column
                            field='quantity'
                            header={
                                this.state.element.electromobility === true ? t('transaction.energyQuantity') : t('transaction.quantity')
                            }
                            bodyClassName='number-value'
                            headerClassName='number-value'
                            body={isHighwayTransaction ? "1" : this.quantityTemplate.bind(this)}
                        />
                        {this.state.element.electromobility === true ? (
                            <Column
                                field='startTime'
                                header={t('transaction.startTime')}
                                bodyClassName='number-value'
                                headerClassName='number-value'
                                body={this.startFinishDateTemplate.bind(this, 'startTime')}
                            />
                        ) : null}
                           
                        {this.state.element.electromobility === true ? (
                            <Column
                                field='endTime'
                                header={t('transaction.endTime')}
                                bodyClassName='number-value'
                                headerClassName='number-value'
                               body={this.startFinishDateTemplate.bind(this, 'endTime')}
                            />
                        ) : null}
                        {this.state.element.electromobility === true ? (
                            <Column
                                field='sumTime'
                                header={t('transaction.summaryTime')}
                                bodyClassName='number-value'
                                headerClassName='number-value'
                                body={this.summaryTimeTemplate.bind(this)}
                            />
                        ) : null}

                        <Column
                            field='priceTotAfter'
                            header={t('transaction.unitPrice')}
                            bodyClassName='number-value'
                            headerClassName='number-value'
                            body={this.unitAmountTemplate.bind(this, 'unitPrice')}
                        />
                        <Column
                            field='gross'
                            header={t('transaction.amount')}
                            bodyClassName='number-value'
                            headerClassName='number-value'
                            body={this.amountTemplate.bind(this, 'amount')}
                        />
                        <Column
                            field='invoiceNo'
                            bodyClassName='number-value'
                            headerClassName='number-value'
                            header={t('transaction.invoiceNumber')}
                        />
                    </DataTable>
                </DivContainer>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={this.props.embedded} />
                {this.renderEditDialog()}
            </React.Fragment>
        );
    }
}

TrasactionDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    visible: false,
    stationId: undefined,
};

TrasactionDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    elementId: PropTypes.number,
    stationId: PropTypes.number,
};

export default withTranslation()(TrasactionDialog);
